import { DatePicker, Select, Option, CheckboxGroup, CheckboxButton} from 'element-ui';

export default {
    name: 'ClubListFilter',
    props: {
        filter: Object,
        blockStatuses: Array,
        standardTypes: Array,
        years: Array,
        currentYear: Number
    },
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,
        [CheckboxButton.name]: CheckboxButton,
        [CheckboxGroup.name]: CheckboxGroup,
    },
    watch: {
        year: {
            immediate: true,
            handler(newVal, oldVal) {
                let filter = { ...this.filter };
                filter.year = this.year;
                filter.options.page = 1;
                this.$emit("update:filter", filter);
            }
        },
        perPage: {
            immediate: true,
            handler() {
                var options = { ...this.filter.options };
                var filter = { ...this.filter };

                filter.options = options;
                filter.options.perPage = this.perPage;
                this.$emit("update:filter", filter);
            }
        },
        currentYear: {
            handler(newVal, oldVal) {
                this.year = newVal;
            }
        }
    },
    data() {
        return {
            isProcessing: false,
            perPage: 5,
            perPageOptions: [5, 10, 25, 50, 100],
            clubName: null,
            year: this.currentYear,
        }
    },
    computed: {
    },
    methods: {
        console(message) {
            if (console && console.log) {
                if (message) {
                    console.log(message);
                }
                else {
                    var date = new Date();
                    console.log("-------> " + date.getMinutes() + ":" + date.getSeconds());
                }
            }
        },
        clubNameChange() {
            let filter = { ...this.filter };
            filter.clubName = this.clubName;
            filter.options.page = 1;
            this.$emit("update:filter", filter);
        }
    },
    mounted() {
    }
};



// WEBPACK FOOTER //
// ./src/components/admin/club/clubs-list/filter-bar/filter-bar.js